var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Chart, ChartCategoryAxis, ChartCategoryAxisItem, ChartSeries, ChartSeriesItem, ChartSeriesItemTooltip, ChartTooltip, ChartValueAxis, ChartValueAxisItem } from '@progress/kendo-react-charts';
import styles from '../ChartWrapper/styles';
var BarChart = function (_a) {
    var _b = _a.barChart, chartCategoryAxisItemProps = _b.chartCategoryAxisItemProps, chartData = _b.chartData, _c = _b.chartProps, chartProps = _c === void 0 ? {} : _c, chartSeriesItemProps = _b.chartSeriesItemProps, _d = _b.chartSeriesItemTooltipProps, chartSeriesItemTooltipProps = _d === void 0 ? {
        formatTitle: function (category) { return category; }
    } : _d, chartStyle = _b.chartStyle, chartValueAxisItemProps = _b.chartValueAxisItemProps, customTooltip = _b.customTooltip, _e = _b.showChartSeriesItemTooltip, showChartSeriesItemTooltip = _e === void 0 ? false : _e;
    var classes = styles();
    var chartTooltip = function (_a) {
        var point = _a.point;
        return (React.createElement("div", { className: classes.chartTooltipWrapper },
            React.createElement("div", { className: classes.chartTooltipTitle }, chartSeriesItemTooltipProps.formatTitle(point.category)),
            React.createElement("div", null,
                React.createElement("div", { className: classes.chartTooltipValueCell },
                    React.createElement("span", { className: classes.bold }, point.value)),
                React.createElement("div", { className: classes.chartTooltipValueDetails },
                    React.createElement("div", { className: classes.chartTooltipIcon, style: { background: "".concat(point.series.color) } }),
                    React.createElement("div", { className: classes.chartTooltipValueDetailsText }, chartSeriesItemTooltipProps.text)))));
    };
    var tooltipRender = function (context) {
        if (customTooltip) {
            var CustomTooltip = customTooltip;
            return React.createElement(CustomTooltip, __assign({}, chartSeriesItemTooltipProps, context));
        }
        return chartTooltip(context);
    };
    return (React.createElement(Chart, __assign({ style: chartStyle }, chartProps, { transitions: false }),
        React.createElement(ChartTooltip, null),
        React.createElement(ChartCategoryAxis, null,
            React.createElement(ChartCategoryAxisItem, __assign({}, chartCategoryAxisItemProps))),
        React.createElement(ChartValueAxis, null,
            React.createElement(ChartValueAxisItem, __assign({}, chartValueAxisItemProps))),
        React.createElement(ChartSeries, null,
            React.createElement(ChartSeriesItem, __assign({}, chartSeriesItemProps, { data: chartData }), showChartSeriesItemTooltip && React.createElement(ChartSeriesItemTooltip, { background: "white", render: tooltipRender })))));
};
export default BarChart;
//# sourceMappingURL=BarChart.js.map